module.exports = __webpack_public_path__ + "img/course_bg2.4737017e.png";